"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _profile = require("../Shapes/profile.shape");

var _features = require("../Shared/store/features");

var _FlowSection = _interopRequireDefault(require("./components/FlowSection/FlowSection"));

var _FlowWrapper = _interopRequireDefault(require("./components/FlowWrapper/FlowWrapper"));

var _SelectProduct = _interopRequireDefault(require("./containers/SelectProduct/SelectProduct"));

var _SelectEmailTemplate = _interopRequireDefault(require("./containers/SelectEmailTemplate/SelectEmailTemplate"));

var _FlowFooter = _interopRequireDefault(require("./components/FlowFooter/FlowFooter"));

var _gift = require("./store/gift/gift.actions");

var _constants = require("./constants");

var _ReviewDetails = _interopRequireDefault(require("./containers/ReviewDetails/ReviewDetails"));

var _SelectInvitationType = _interopRequireDefault(require("./containers/SelectInvitationType/SelectInvitationType"));

var _GiftInviteUrl = _interopRequireDefault(require("./components/GiftInviteUrl/GiftInviteUrl"));

var _CampaignDetails = _interopRequireDefault(require("./components/CampaignDetails/CampaignDetails"));

var _ProductDetailsForm = _interopRequireDefault(require("./components/ProductDetails/ProductDetailsForm"));

var _InvitationDetails = _interopRequireDefault(require("./components/InvitationDetails/InvitationDetails"));

var _DiscardGiftConfirmation = _interopRequireDefault(require("./components/DiscardGiftConfirmation/DiscardGiftConfirmation"));

var _SenderGiftLanguage = _interopRequireDefault(require("./containers/SenderGiftLanguage/SenderGiftLanguage"));

var _SelectRecipientRequirements = _interopRequireDefault(require("./containers/SelectRecipientRequirements/SelectRecipientRequirements"));

var _useProductDetails = require("./hooks/useProductDetails");

var _marketplace = require("./store/marketplace/marketplace.selector");

var _GiftMarketplaceProducts = _interopRequireDefault(require("./containers/GiftMarketplaceProducts/GiftMarketplaceProducts"));

var _NeedMoreInfo = _interopRequireDefault(require("./components/NeedMoreInfo/NeedMoreInfo"));

var _waitForGiftResearchingEffect = require("./hooks/waitForGiftResearchingEffect");

var _FlowSectionLoader = _interopRequireDefault(require("./components/FlowSectionLoader/FlowSectionLoader"));

var _gift2 = require("./store/gift/gift.selector");

var _recipient = require("./store/recipient/recipient.actions");

var _giftResearchTypes = require("./constants/giftResearchTypes.constant");

var _useGift2 = require("./hooks/useGift");

var _useGiftContext = require("./hooks/useGiftContext");

var _VideoLandingPage = _interopRequireDefault(require("./containers/VideoLandingPage/VideoLandingPage"));

var _GiftVideoUrlBlocked = _interopRequireDefault(require("./components/GiftVideoUrlBlocked/GiftVideoUrlBlocked"));

var _EmailIntegration = _interopRequireDefault(require("./containers/EmailIntegration/EmailIntegration"));

var _GiftMessage = _interopRequireDefault(require("./containers/GiftMessage/GiftMessage"));

var _GiftVideoVidyardDetails = _interopRequireDefault(require("./components/GiftVideoVidyardDetails/GiftVideoVidyardDetails"));

var _invitationType = require("./store/gift/invitationType");

var _useTrackGiftingFlow = require("./hooks/useTrackGiftingFlow");

var _user = require("./shapes/user.shape");

var _GiftMessagePreview = _interopRequireDefault(require("./containers/GiftMessage/GiftMessagePreview"));

var _useCampaigns = require("./hooks/useCampaigns");

var _SentGiftHeader = _interopRequireDefault(require("./components/SentGiftHeader/SentGiftHeader"));

var _SentGiftExpireAction = _interopRequireDefault(require("./components/SentGiftExpireAction/SentGiftExpireAction"));

var _GiftProcessing = _interopRequireDefault(require("./components/GiftProcessing/GiftProcessing"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    loaderWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: spacing(8)
    },
    // Opted Out Message
    boxDialog: {
      padding: spacing(2, 5, 5),
      borderRadius: 5,
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.1)',
      background: palette.common.white,
      borderTop: "4px solid ".concat(palette.orange.main)
    },
    disabledBoxMessage: {
      padding: spacing(3),
      background: palette.red.brickRed10,
      border: "1px solid ".concat(palette.red.main)
    },
    disabledBoxMessageIcon: {
      color: palette.red.main
    },
    avatar: {
      backgroundColor: palette.orange.main,
      width: 46,
      height: 46,
      marginRight: spacing(2)
    },
    icon: {
      color: 'white'
    },
    tryButton: {
      backgroundColor: palette.orange.main,
      color: 'white'
    }
  };
});

var SendGiftModule = function SendGiftModule(_ref2) {
  var _gift$required_action, _gift$required_action2;

  var giftId = _ref2.giftId,
      profileName = _ref2.profileName,
      contact = _ref2.contact,
      onNeedMoreInfo = _ref2.onNeedMoreInfo,
      onTryAnotherEmail = _ref2.onTryAnotherEmail,
      successfullHeader = _ref2.successfullHeader,
      _ref2$settings = _ref2.settings,
      user = _ref2$settings.user,
      _ref2$settings$emailI = _ref2$settings.emailIntegrationSettingsUrl,
      emailIntegrationSettingsUrl = _ref2$settings$emailI === void 0 ? '' : _ref2$settings$emailI,
      _ref2$settings$emailI2 = _ref2$settings.emailIntegrationStrategy,
      emailIntegrationStrategy = _ref2$settings$emailI2 === void 0 ? '' : _ref2$settings$emailI2,
      _ref2$settings$sideba = _ref2$settings.sidebarMode,
      sidebarMode = _ref2$settings$sideba === void 0 ? true : _ref2$settings$sideba,
      _ref2$settings$dashbo = _ref2$settings.dashboardHost,
      dashboardHost = _ref2$settings$dashbo === void 0 ? '' : _ref2$settings$dashbo,
      _ref2$settings$vidyar = _ref2$settings.vidyardClientId,
      vidyardClientId = _ref2$settings$vidyar === void 0 ? '' : _ref2$settings$vidyar,
      _ref2$settings$apiHos = _ref2$settings.apiHost,
      apiHost = _ref2$settings$apiHos === void 0 ? '' : _ref2$settings$apiHos,
      onSendCampaignGift = _ref2.onSendCampaignGift,
      onClose = _ref2.onClose,
      canSendAnotherGift = _ref2.canSendAnotherGift,
      spaClient = _ref2.spaClient;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  var hasSalesforceHasOptedOutFF = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.SALESFORCE_HAS_OPTED_OUT));

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDiscardConfirmationOpen = _useState2[0],
      setIsDiscardConfirmationOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      productPreviewId = _useState4[0],
      setProductPreviewId = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isMarketplaceVisible = _useState6[0],
      setMarketplaceVisibility = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isEmailIntegrationSkipped = _useState8[0],
      setEmailIntegrationSkipping = _useState8[1];

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var exchangeProduct = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _marketplace.getProductById)(productPreviewId);
  }, [productPreviewId]));
  var prospectDescription = (0, _reactRedux.useSelector)(_gift2.getProspectDescription) || '';
  var videoType = (0, _reactRedux.useSelector)(_gift2.getGiftVideoType) || '';
  var recipientVideoMessage = (0, _reactRedux.useSelector)(_gift2.getGiftVideoMessage) || '';
  var recipientVidyardVideo = (0, _reactRedux.useSelector)(_gift2.getGiftVidyardVideo) || '';
  var defaultEmailProvider = (0, _reactRedux.useSelector)(_gift2.getGiftEmailProvider);
  var marketplaceProduct = (0, _reactRedux.useSelector)(_marketplace.getProduct);
  var giftUpdatedAt = (0, _reactRedux.useSelector)(_gift2.getFormattedUpdateAt);

  var _useGift = (0, _useGift2.useGift)(),
      gift = _useGift.gift,
      campaign = _useGift.campaign,
      product = _useGift.product,
      isGiftContactOptedOut = _useGift.isGiftContactOptedOut,
      isGiftContactSyncLoading = _useGift.isGiftContactSyncLoading,
      isLoading = _useGift.isLoading,
      recipient = _useGift.recipient,
      isMarketplaceAllowed = _useGift.isMarketplaceAllowed;

  var onSendGiftToCampaign = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow — clicked send another gift in the campaign', {
      campaign_id: campaign.id
    });
    onSendCampaignGift(campaign.id);
  }, [trackEvent, campaign, onSendCampaignGift]);

  var _useProductReview = (0, _useProductDetails.useProductReview)(),
      fetchByGift = _useProductReview.fetchByGift;

  var trackStepEdit = (0, _useTrackGiftingFlow.useTrackGiftingFlowStepEdited)();
  var researchType = (0, _reactRedux.useSelector)(_gift2.getGiftResearchType);
  var processingState = (0, _reactRedux.useSelector)(_gift2.getProcessingState);
  var giftLinkState = (0, _reactRedux.useSelector)(_gift2.getGiftLinkState);
  var selectProductState = (0, _reactRedux.useSelector)(_gift2.getSelectProductState);
  var selectTemplateState = (0, _reactRedux.useSelector)(_gift2.getSelectTemplateState);
  var selectInvitationTypeState = (0, _reactRedux.useSelector)(_gift2.getSelectInvitationTypeState);
  var editTemplateMessageState = (0, _reactRedux.useSelector)(_gift2.getTemplateDetailsState);
  var requirementsStateWithoutVideo = (0, _reactRedux.useSelector)(_gift2.getRequirementsState);
  var requirementsStateWithVideo = (0, _reactRedux.useSelector)(_gift2.getRequirementsStateWithVideo);
  var videoLandingPageState = (0, _reactRedux.useSelector)(_gift2.getVideoLandingPageState);
  var reviewState = (0, _reactRedux.useSelector)(_gift2.getReviewState);
  var needMoreInfoState = (0, _reactRedux.useSelector)(_gift2.getNeedMoreInfoState);
  var hasEmailIntegration = (0, _reactRedux.useSelector)(_gift2.getHasEmailIntegration);
  var hasCalendarIntegration = (0, _reactRedux.useSelector)(_gift2.getHasCalendarIntegration);
  var giftProductId = (0, _reactRedux.useSelector)(_gift2.getGiftProductId);
  var statusId = (0, _reactRedux.useSelector)(_gift2.getGiftStatusId);
  var contactAddress = (0, _reactRedux.useSelector)(_invitationType.getSelectedInvitationTypeContactAddress);
  var invitationType = (0, _reactRedux.useSelector)(_invitationType.getSelectedInvitationType);
  var isDirectDeliveryMethod = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var giftCampaign = (0, _reactRedux.useSelector)(_gift2.getGiftCampaign);
  var requireEmailIntegration = (0, _reactRedux.useSelector)(_gift2.getRequireEmailIntegration);
  var isDkimProvider = (0, _reactRedux.useSelector)(_gift2.getIsDkimEmailProvider);
  var marketplaceRangeExchangeDenomination = (0, _reactRedux.useSelector)(_marketplace.getMarketplaceExchangeDenomination);
  var isUserEmailConnected = requireEmailIntegration === 'not_show' || hasEmailIntegration || hasCalendarIntegration && isDkimProvider || isEmailIntegrationSkipped;
  var senderId = R.pathOr(null, ['sender', 'id'], gift);
  var acceptedProduct = (0, _reactRedux.useSelector)(_gift2.getAcceptedProduct);
  var acceptedProductState = (0, _reactRedux.useSelector)(_gift2.getAcceptedProductState);
  var isGiftSendingCompleted = (0, _reactRedux.useSelector)(_gift2.getIsGiftSendingCompleted);
  var isContactInfoSynced = researchType === _giftResearchTypes.researchTypes.AI && processingState === _constants.stepState.ACTIVE;
  (0, _waitForGiftResearchingEffect.useWaitForGiftResearchingEffect)();
  (0, _useTrackGiftingFlow.useTrackGiftingFlowStepPassedEffect)();
  (0, _useTrackGiftingFlow.useTrackSendGiftOpenedEffect)(user);
  var isRecipientVideoAvailableToShow = gift && !!gift.recipient_video && (!gift.recipient_video.locked || gift.recipient_video.locked && videoType !== _ui.VIDEO_TYPE_DISABLED);
  var isTryAnotherEmailAvailable = onTryAnotherEmail !== undefined;
  var videoMessage;

  switch (videoType) {
    case _ui.VIDEO_TYPE_EMBED:
      videoMessage = recipientVideoMessage;
      break;

    case _ui.VIDEO_TYPE_VIDYARD:
      videoMessage = recipientVidyardVideo;
      break;

    default:
      videoMessage = '';
      break;
  }

  var requirementsState = (0, _react.useMemo)(function () {
    return isRecipientVideoAvailableToShow ? requirementsStateWithVideo : requirementsStateWithoutVideo;
  }, [isRecipientVideoAvailableToShow, requirementsStateWithVideo, requirementsStateWithoutVideo]);
  var confirmModalsStyles = (0, _react.useMemo)(function () {
    return sidebarMode ? {
      width: 600
    } : {
      top: 0,
      width: '100%'
    };
  }, [sidebarMode]);
  var giftContextValue = (0, _react.useMemo)(function () {
    return {
      user,
      sidebarMode,
      emailIntegrationSettingsUrl,
      emailIntegrationStrategy,
      dashboardHost,
      vidyardClientId,
      contact
    };
  }, [user, contact, sidebarMode, emailIntegrationSettingsUrl, emailIntegrationStrategy, dashboardHost, vidyardClientId]);
  (0, _react.useEffect)(function () {
    setProductPreviewId(null);
  }, [giftProductId]);
  var handleChooseProductFromPreview = (0, _react.useCallback)(function () {
    if (!isMarketplaceVisible) {
      if (!multipleValues || !marketplaceRangeExchangeDenomination) {
        dispatch((0, _gift.selectProduct)(giftId, productPreviewId));
      } else {
        dispatch((0, _invitationType.resetInvitationType)());
        dispatch((0, _gift.selectExchangeProduct)(giftId, {
          id: productPreviewId,
          denomination: marketplaceRangeExchangeDenomination,
          denomination_currency_id: marketplaceProduct.giftCardRange.currencyId
        }));
      }
    } else {
      dispatch((0, _gift.selectExchangeProduct)(giftId, {
        id: exchangeProduct.id,
        denomination: multipleValues && marketplaceRangeExchangeDenomination ? marketplaceRangeExchangeDenomination : exchangeProduct.denomination,
        denomination_currency_id: exchangeProduct.denomination_currency_id
      }));
      dispatch((0, _invitationType.resetInvitationType)());
      setMarketplaceVisibility(false);
    }
  }, [isMarketplaceVisible, multipleValues, marketplaceRangeExchangeDenomination, dispatch, giftId, productPreviewId, exchangeProduct, marketplaceProduct]);
  (0, _react.useEffect)(function () {
    if (productPreviewId) {
      fetchByGift({
        productId: productPreviewId,
        giftId
      });
    }
  }, [fetchByGift, productPreviewId, giftId]);
  (0, _react.useEffect)(function () {
    dispatch((0, _gift.giftLoadRequest)(giftId));
    return function () {
      return dispatch((0, _gift.giftCreateReset)());
    };
  }, [dispatch, giftId]);
  (0, _react.useEffect)(function () {
    if (hasSalesforceHasOptedOutFF && recipient !== null && recipient !== void 0 && recipient.email && isContactInfoSynced) {
      dispatch((0, _gift.giftVerifyAvailableContact)(recipient.email));
    }
  }, [dispatch, hasSalesforceHasOptedOutFF, isContactInfoSynced, recipient]);
  (0, _useCampaigns.useCampaignsRequest)(contact.countryId);
  var hasInvitationDetails = R.compose(R.and(contactAddress), R.not, R.equals('email'), R.toLower, R.pathOr('email', ['gift_invitation_item', 'type']))(gift);
  var renderInvitationDetails = (0, _react.useCallback)(function () {
    return hasInvitationDetails && /*#__PURE__*/_react.default.createElement(_InvitationDetails.default, {
      contactAddress: contactAddress
    });
  }, [contactAddress, hasInvitationDetails]);

  var container = _react.default.useRef(null);

  var title = _react.default.useRef(null);

  (0, _react.useEffect)(function () {
    if (statusId > _constants.giftStatuses.PRODUCTS_PROPOSED && title.current) {
      title.current.scrollIntoView(true);
    }
  }, [statusId]);
  var onProposedProductPreview = (0, _react.useCallback)(function (productId) {
    setProductPreviewId(productId);
    trackEvent('Gifting flow - clicked proposed product preview', {
      product_id: productId,
      gift_id: gift.id,
      team_id: campaign && campaign.team.id
    });
  }, [campaign, gift, trackEvent]);
  var handleMarketplaceProductPreview = (0, _react.useCallback)(function (productId) {
    setProductPreviewId(productId);
    trackEvent('Gifting flow - clicked marketplace product preview', {
      product_id: productId,
      gift_id: gift.id,
      team_id: campaign && campaign.team.id
    });
  }, [campaign, gift, trackEvent]);
  var handleCloseMarketplace = (0, _react.useCallback)(function () {
    setMarketplaceVisibility(false);
  }, []);
  var handleClosePreview = (0, _react.useCallback)(function () {
    setProductPreviewId(null);
  }, []);
  var editClickHandler = (0, _react.useCallback)(function (step) {
    return function () {
      return dispatch((0, _gift.giftEditStep)(step));
    };
  }, [dispatch]);
  var showMarketplace = (0, _react.useCallback)(function () {
    setMarketplaceVisibility(true);
    trackEvent('Gifting flow - clicked checkout marketplace on the select product page', {
      gift_id: giftId,
      team_id: campaign && campaign.team.id
    });
  }, [trackEvent, giftId, campaign]);
  var discardGiftHandler = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow — clicked discard gift', {
      gift_id: giftId,
      team_id: campaign && campaign.team.id
    });
    setIsDiscardConfirmationOpen(true);
  }, [trackEvent, giftId, campaign]);
  var editProductHandler = (0, _react.useCallback)(function () {
    trackStepEdit(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.SELECT_PRODUCT);
    editClickHandler(_constants.steps.SELECT_PRODUCT)();
  }, [trackStepEdit, editClickHandler]);
  var editInvitationTypeHandler = (0, _react.useCallback)(function () {
    trackStepEdit(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.SELECT_INVITATION_TYPE);
    editClickHandler(_constants.steps.SELECT_INVITATION_TYPE)();
  }, [trackStepEdit, editClickHandler]);
  var editMessageHandler = (0, _react.useCallback)(function () {
    trackStepEdit(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.EDIT_MESSAGE);
    editClickHandler(_constants.steps.EDIT_TEMPLATE_MESSAGE)();
  }, [trackStepEdit, editClickHandler]);
  var editRequirementsHandler = (0, _react.useCallback)(function () {
    trackStepEdit(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.OPTIONAL_STEPS);
    editClickHandler(_constants.steps.REQUIREMENTS)();
  }, [trackStepEdit, editClickHandler]);
  var editVideoMessageHandler = (0, _react.useCallback)(function () {
    trackStepEdit(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.VIDEO_LANDING_PAGE);
    editClickHandler(_constants.steps.VIDEO_LANDING_PAGE)();
  }, [trackStepEdit, editClickHandler]);
  var skipEmailIntegration = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow - email connection skipped', {
      gift_id: giftId,
      sender_id: senderId
    });
    setEmailIntegrationSkipping(true);
  }, [senderId, giftId, trackEvent]);
  var onTryAnotherEmailClick = (0, _react.useCallback)(function () {
    dispatch((0, _recipient.giftCreateRecipientReset)());
    onTryAnotherEmail();
  }, [dispatch, onTryAnotherEmail]);
  (0, _react.useEffect)(function () {
    if (isDirectDeliveryMethod && requirementsState === _constants.stepState.ACTIVE) {
      var giftProspect = gift.required_actions.locked ? null : gift.required_actions.prospect;
      dispatch((0, _gift.giftSetGiftActionsRequest)({
        giftId,
        // below does not matter in case of direct mail delivery
        giftActionsId: 1,
        prospect: giftProspect
      }));
    }
  }, [dispatch, giftId, gift === null || gift === void 0 ? void 0 : (_gift$required_action = gift.required_actions) === null || _gift$required_action === void 0 ? void 0 : _gift$required_action.locked, gift === null || gift === void 0 ? void 0 : (_gift$required_action2 = gift.required_actions) === null || _gift$required_action2 === void 0 ? void 0 : _gift$required_action2.prospect, isDirectDeliveryMethod, requirementsState]);

  if (hasSalesforceHasOptedOutFF && isGiftContactOptedOut) {
    return /*#__PURE__*/_react.default.createElement(_FlowWrapper.default, {
      container: true,
      direction: "column",
      wrap: "nowrap"
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      p: 3
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: classes.boxDialog
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      className: classes.avatar
    }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      className: classes.icon,
      icon: "user"
    })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "H3-Dark"
    }, "This email has opted out")), /*#__PURE__*/_react.default.createElement(_material.Box, {
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      "data-testid": "optedOutContact"
    }, "This email ", recipient.email, " has opted out of email communications from your org and cannot be gifted.", isTryAnotherEmailAvailable && 'Please try another email.')), isTryAnotherEmailAvailable && /*#__PURE__*/_react.default.createElement(_material.Box, {
      mt: 3,
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
      className: classes.tryButton,
      variant: "contained",
      onClick: onTryAnotherEmailClick
    }, "Try another email")))));
  }

  if (isContactInfoSynced) {
    return /*#__PURE__*/_react.default.createElement(_FlowWrapper.default, {
      container: true,
      direction: "column",
      wrap: "nowrap"
    }, /*#__PURE__*/_react.default.createElement(_FlowSectionLoader.default, null, "Give us a second while we gather information on ", contact.fullName, "\u2026"));
  }

  var renderDisabledGiftMessage = /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 1,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.disabledBoxMessage
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H3-Dark",
    color: "red.main"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    className: classes.disabledBoxMessageIcon,
    icon: "envelope"
  }), " This gift has been disabled")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    "data-testid": "disabledGiftMessage"
  }, "This may be due to a user disabling the gift, a gift operations process, or because the email", ' ', recipient === null || recipient === void 0 ? void 0 : recipient.email, " has opted out of email communications from your org and cannot to be gifted. Please check your opt out rules in Salesforce for more information or email ", recipient === null || recipient === void 0 ? void 0 : recipient.email, " for additional questions."))));

  var renderSentGiftHeader = statusId > _constants.giftStatuses.PRODUCTS_PROPOSED ? /*#__PURE__*/_react.default.createElement(_SentGiftHeader.default, {
    ref: title,
    name: profileName
  }, successfullHeader) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  var showLoader = isLoading && !gift || hasSalesforceHasOptedOutFF && isLoading && isGiftSendingCompleted || hasSalesforceHasOptedOutFF && isGiftContactSyncLoading;
  return /*#__PURE__*/_react.default.createElement(_useGiftContext.GiftContextProvider, {
    value: giftContextValue
  }, /*#__PURE__*/_react.default.createElement(_FlowWrapper.default, {
    container: true,
    direction: "column",
    wrap: "nowrap",
    ref: container
  }, showLoader && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    "data-testid": "SendGiftModule.Loading"
  })), !showLoader && gift && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GiftMarketplaceProducts.default, {
    countryId: contact.countryId,
    giftId: parseInt(giftId, 10),
    isMarketplaceOpen: isMarketplaceVisible,
    onClose: handleCloseMarketplace,
    onProductPreview: handleMarketplaceProductPreview,
    onClosePreview: handleClosePreview,
    previewedProductId: productPreviewId,
    onChooseProduct: handleChooseProductFromPreview
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !productPreviewId && !isMarketplaceVisible
  }, statusId === _constants.giftStatuses.DISABLED ? renderDisabledGiftMessage : renderSentGiftHeader, reviewState === _constants.stepState.ACTIVE && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark"
  }, "Review your invite")), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: giftLinkState,
    icon: "laptop",
    renderPassed: function renderPassed() {
      return /*#__PURE__*/_react.default.createElement(_GiftInviteUrl.default, {
        link: gift.recipient_landing_page
      });
    }
  }), statusId > _constants.giftStatuses.PRODUCTS_PROPOSED && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Here are your ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " details")), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: _constants.stepState.PASSED,
    icon: "lightbulb-on",
    title: "Campaign",
    details: "Details",
    value: giftCampaign ? giftCampaign.name : null,
    renderDetails: function renderDetails() {
      return giftCampaign && /*#__PURE__*/_react.default.createElement(_CampaignDetails.default, {
        apiHost: apiHost,
        campaign: giftCampaign
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: needMoreInfoState,
    icon: "question-circle",
    title: "Need more info",
    value: "VALUE",
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_NeedMoreInfo.default, {
        onNeedMoreInfo: onNeedMoreInfo
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: spaClient === _constants.SPA_CLIENT.SALESFORCE ? processingState : _constants.stepState.HIDDEN,
    icon: "question-circle",
    title: "How",
    value: "Ask Alyce for help",
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_GiftProcessing.default, {
        showMarketplace: isMarketplaceAllowed,
        giftId: gift.id,
        onClose: onClose,
        onSendCampaignGift: onSendGiftToCampaign,
        setShowMarketplace: setMarketplaceVisibility,
        canSendAnotherGift: canSendAnotherGift
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    showEdit: statusId <= _constants.giftStatuses.PRODUCTS_PROPOSED && selectProductState === _constants.stepState.PASSED,
    disabled: isLoading,
    onEdit: editProductHandler,
    state: selectProductState,
    icon: product ? product.image : 'gift',
    image: product ? product.image : null,
    details: "Details",
    title: statusId >= _constants.giftStatuses.GIFT_EMAIL_SENT ? 'Sent Gift' : 'Gift',
    value: product ? product.name : null,
    renderDetails: function renderDetails() {
      return product && /*#__PURE__*/_react.default.createElement(_ProductDetailsForm.default, {
        product: product
      });
    },
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_SelectProduct.default, {
        showMarketplace: showMarketplace,
        onPreview: onProposedProductPreview
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: acceptedProductState,
    icon: acceptedProduct ? acceptedProduct.image : 'gift',
    image: acceptedProduct ? acceptedProduct.image : null,
    details: "Details",
    title: "Accepted Gift",
    value: acceptedProduct ? acceptedProduct.name : null,
    renderDetails: function renderDetails() {
      return acceptedProduct && /*#__PURE__*/_react.default.createElement(_ProductDetailsForm.default, {
        product: acceptedProduct
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: selectInvitationTypeState,
    showEdit: statusId <= _constants.giftStatuses.PRODUCTS_PROPOSED && selectInvitationTypeState === _constants.stepState.PASSED,
    disabled: isLoading,
    onEdit: editInvitationTypeHandler,
    icon: selectInvitationTypeState === _constants.stepState.PASSED ? undefined : 'shipping-fast',
    image: invitationType && invitationType.image,
    title: "Invitation",
    value: invitationType ? invitationType.name : '',
    details: hasInvitationDetails ? 'Details' : null,
    renderDetails: renderInvitationDetails,
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_SelectInvitationType.default, {
        recipientName: profileName,
        teamId: campaign ? campaign.team.id : 0
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: selectTemplateState,
    disabled: isLoading,
    icon: "comments-alt",
    title: "What would you like to say?",
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_SelectEmailTemplate.default, {
        giftId: giftId
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    showEdit: statusId <= _constants.giftStatuses.PRODUCTS_PROPOSED && editTemplateMessageState === _constants.stepState.PASSED,
    disabled: isLoading,
    onEdit: editMessageHandler,
    state: editTemplateMessageState,
    icon: "comments-alt",
    title: "Message",
    zIndex: 2,
    renderPassed: function renderPassed() {
      return /*#__PURE__*/_react.default.createElement(_GiftMessagePreview.default, null);
    },
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
        in: isUserEmailConnected || isDirectDeliveryMethod,
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_GiftMessage.default, null)), !isDirectDeliveryMethod && /*#__PURE__*/_react.default.createElement(_material.Collapse, {
        in: !isUserEmailConnected,
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_EmailIntegration.default, {
        linkToIntegration: emailIntegrationSettingsUrl,
        onSkipIntegration: skipEmailIntegration,
        integrationStrategy: emailIntegrationStrategy
      })));
    }
  }), isRecipientVideoAvailableToShow && /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    showEdit: gift.status_id <= _constants.giftStatuses.PRODUCTS_PROPOSED && videoLandingPageState === _constants.stepState.PASSED && !gift.recipient_video.locked,
    disabled: isLoading,
    onEdit: editVideoMessageHandler,
    state: videoLandingPageState,
    icon: "video",
    title: "Video Landing Page",
    isValueLink: true,
    value: videoMessage || 'None',
    renderPassed: function renderPassed() {
      return gift.recipient_video.locked ? /*#__PURE__*/_react.default.createElement(_GiftVideoUrlBlocked.default, null) : null;
    },
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_VideoLandingPage.default, null);
    },
    details: videoType === _ui.VIDEO_TYPE_VIDYARD ? 'Details' : undefined,
    renderDetails: function renderDetails() {
      return videoType === _ui.VIDEO_TYPE_VIDYARD && /*#__PURE__*/_react.default.createElement(_GiftVideoVidyardDetails.default, {
        thumbnail: gift.recipient_video.vidyard_image
      });
    }
  }), !isDirectDeliveryMethod && /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    showEdit: statusId <= _constants.giftStatuses.PRODUCTS_PROPOSED && requirementsState === _constants.stepState.PASSED,
    disabled: isLoading,
    onEdit: editRequirementsHandler,
    state: requirementsState,
    icon: "clipboard-list",
    title: "Requirements",
    value: prospectDescription || 'None',
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_SelectRecipientRequirements.default, {
        prospectDescription: prospectDescription
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: reviewState,
    icon: ['fab', 'telegram-plane'],
    title: "Review and send your invite",
    renderActive: function renderActive() {
      return /*#__PURE__*/_react.default.createElement(_ReviewDetails.default, {
        profileName: profileName,
        disabled: isLoading,
        defaultProvider: defaultEmailProvider
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_FlowSection.default, {
    state: statusId === _constants.giftStatuses.SCHEDULED ? _constants.stepState.PASSED : _constants.stepState.HIDDEN,
    disabled: isLoading,
    icon: "calendar-alt",
    title: "Sending",
    value: gift.scheduled_at && /*#__PURE__*/_react.default.createElement(_ui.DateFormat, {
      value: gift.scheduled_at,
      timezone: "US/Eastern",
      format: "MM/DD/YY @ hh:mma z"
    })
  }), statusId <= _constants.giftStatuses.PRODUCTS_PROPOSED && /*#__PURE__*/_react.default.createElement(_FlowFooter.default, {
    giftUpdatedAt: giftUpdatedAt,
    discardGiftHandler: discardGiftHandler
  }), /*#__PURE__*/_react.default.createElement(_SentGiftExpireAction.default, null))), /*#__PURE__*/_react.default.createElement(_DiscardGiftConfirmation.default, (0, _extends2.default)({
    isOpen: isDiscardConfirmationOpen,
    recipientName: profileName,
    onCancel: function onCancel() {
      return setIsDiscardConfirmationOpen(false);
    },
    onSubmit: function onSubmit() {
      return dispatch((0, _gift.giftDiscardRequest)(gift.id));
    }
  }, confirmModalsStyles))));
};

SendGiftModule.propTypes = {
  giftId: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func,
  contact: _profile.profileShape.isRequired,
  onNeedMoreInfo: _propTypes.default.func.isRequired,
  onSendCampaignGift: _propTypes.default.func,
  onTryAnotherEmail: _propTypes.default.func,
  settings: _propTypes.default.shape({
    user: _user.User.isRequired,
    emailIntegrationSettingsUrl: _propTypes.default.string,
    sidebarMode: _propTypes.default.bool,
    emailIntegrationStrategy: _propTypes.default.string,
    dashboardHost: _propTypes.default.string,
    vidyardClientId: _propTypes.default.string,
    apiHost: _propTypes.default.string
  }).isRequired,
  profileName: _propTypes.default.string,
  canSendAnotherGift: _propTypes.default.bool,
  successfullHeader: _propTypes.default.node,
  spaClient: _propTypes.default.oneOf(_constants.SPA_CLIENT_LIST)
};
SendGiftModule.defaultProps = {
  profileName: '',
  canSendAnotherGift: true,
  successfullHeader: null,
  onTryAnotherEmail: undefined,
  onClose: function onClose() {},
  onSendCampaignGift: function onSendCampaignGift() {},
  spaClient: ''
};
var _default = SendGiftModule;
exports.default = _default;